export class SubSpecialty {
    id: string;
    sub_specialty_name: string;
    specialty_id: string;
    specialty_name: string;
    collection_id?: string;
    general_sub_specialty?: boolean;
}